import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";

export const AliasesLayout = () => {

    const {
        allowedActions
    } = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListAliases') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateAlias') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/aliases'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetAlias') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/aliases'/>
                    )
                }
            />

        </Routes>
    );
};
